import { buttonClick, statusChanged } from '@wix/bi-logger-wixlabs-users/v2';
import {
  instagramFeedAppLoadsStartLoading,
  instagramFeedAppLoads,
  clickOnButtonOrLink,
  instagramViewPost,
} from '@wix/bi-logger-wixlabs-ugc/v2';
import {
  instagramFeedWidgetAddedSrc63Evid28,
  instagramFeedWidgetDeletedSrc63Evid31,
  instagramFeedAppLoadsV2Src63Evid29,
} from '@wix/bi-logger-labs-data/v2';

interface LogParams {
  [key: string]: any;
}

interface ReportProps {
  evid: number;
  src: number;
  endpoint: string;
  params: LogParams;
}

export type BiFunction = (...args: any[]) => ReportProps;

const actionType = [
  'buttonClick',
  'appLoadedStart',
  'appLoadedEnd',
  'statusChanged',
  'clickOnButtonOrLink',
  'instagramViewPost',
  'instagramFeedWidgetAddedSrc63Evid28',
  'feedLoadStarted',
  'feedLoadFinished',
  'widgetViewed',
  'widgetDeleted',
] as const;

const entity = [null, 'preset'] as const;

export type BiActionType = (typeof biCommon.actionType)[number];

export const biCommon = {
  actionType,
  entity,
};

const BI_FUNCS: { [key in BiActionType]: BiFunction } = {
  buttonClick,
  clickOnButtonOrLink,
  statusChanged,
  instagramViewPost,
  appLoadedStart: instagramFeedAppLoadsStartLoading,
  appLoadedEnd: instagramFeedAppLoads,
  instagramFeedWidgetAddedSrc63Evid28,
  feedLoadStarted: instagramFeedAppLoadsV2Src63Evid29,
  feedLoadFinished: instagramFeedAppLoadsV2Src63Evid29,
  widgetViewed: instagramFeedAppLoadsV2Src63Evid29,
  widgetDeleted: instagramFeedWidgetDeletedSrc63Evid31,
};

export const getBiEventFunction = (
  biType: BiActionType = 'buttonClick',
): BiFunction => BI_FUNCS[biType];
